import { render, staticRenderFns } from "./internalunit.vue?vue&type=template&id=b86c2e28&scoped=true"
import script from "./internalunit.vue?vue&type=script&lang=js"
export * from "./internalunit.vue?vue&type=script&lang=js"
import style0 from "./internalunit.vue?vue&type=style&index=0&id=b86c2e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c2e28",
  null
  
)

export default component.exports